export const FILE_TYPE = 'FILE_TYPE' as const;
export const HIDDEN_QUESTION_TYPE = 'HIDDEN_QUESTION_TYPE' as const;
export const HIDDEN_FOOTER_TYPE = 'HIDDEN_FOOTER_TYPE' as const;
export const MATRIX_TYPE = 'MATRIX_TYPE' as const;
export const MEDIAFILE_TYPE = 'MEDIAFILE_TYPE' as const;
export const MULTIPLE_ANSWERS_TYPE = 'MULTIPLE_ANSWERS_TYPE' as const;
export const RANK_TYPE = 'RANK_TYPE' as const;
export const RATING_TYPE = 'RATING_TYPE' as const;
export const SINGLE_TYPE = 'SINGLE_TYPE' as const;
export const TEXTAREA_TYPE = 'TEXTAREA_TYPE' as const;
export const WITHOUT_ANSWERS_TYPE = 'WITHOUT_ANSWERS_TYPE' as const;
export const NO_HEADER_TEXT = 'NO_HEADER_TEXT' as const;
export const ONLY_EXCLUSIVE_ANSWERS = 'ONLY_EXCLUSIVE_ANSWERS' as const;

export type PollTrait =
  | typeof FILE_TYPE
  | typeof HIDDEN_FOOTER_TYPE
  | typeof HIDDEN_QUESTION_TYPE
  | typeof MATRIX_TYPE
  | typeof MEDIAFILE_TYPE
  | typeof MULTIPLE_ANSWERS_TYPE
  | typeof RANK_TYPE
  | typeof RATING_TYPE
  | typeof SINGLE_TYPE
  | typeof TEXTAREA_TYPE
  | typeof WITHOUT_ANSWERS_TYPE
  | typeof NO_HEADER_TEXT
  | typeof ONLY_EXCLUSIVE_ANSWERS;

export interface Config {
  name: string;
  title: string;
  tracker?: (question: any) => (trackingData: AnswerTrackerData) => AnswerTrackerData;
}

export interface PollConfig extends Config {
  traits: PollTrait[];
}

export interface CommonTrackerData {
  version: string;
  source: string;
  referer: string;
  quiz_id: string;
  polls_ic: string;
  user_id: string | null;
  twork_id: string | null;
  questions_count: number;
  wave: number | undefined;
  revision: string | undefined;
  retry?: number;
}

export interface FinishTrackerData extends CommonTrackerData {
  final_id: string;
  final_index: number;
  collected_score: number;
  correct_answers_count: number;
}
export interface FinalClickTrackedData extends CommonTrackerData {
  final_id: number;
  final_index: number;
}

export interface LinkClickTrackedData extends CommonTrackerData {
  external_url: string;
}

export interface MediaProgressTrackerData extends CommonTrackerData {
  question_index: number;
  question_id: string;
  question_text?: string;
  question_type: string;
  answers_ids?: string;
  media_progress: string;
}

export interface OverallData extends CommonTrackerData {
  answers_overall: unknown[];
  question_count: number;
  final_id: string;
  final_number: string;
  correct_answers_number: number;
  collected_score: number;
}

export type SomeTrackerData =
  | CommonTrackerData
  | AnswerTrackerData
  | FinalClickTrackedData
  | FinishTrackerData
  | LinkClickTrackedData
  | MediaProgressTrackerData
  | OverallData;

/** Значения с undefined отправляются как пустые строки. Значения с null не отправляются */
export interface AnswerTrackerData extends CommonTrackerData {
  set_id: string | null;
  group_id: string | null;
  question_deck_id: string | null;
  question_id: string;
  question_index: number;
  question_text: string;
  question_type: string;
  elapsed_time: number | null | undefined;
  answered_ids: (string | number)[];
  time_expired: number;
  answered_indexes: (string | number)[];
  answered_others: string | null;
  answers: string[] | string;
  file_is_uploaded?: number;
  collected_score?: number;

  current_hash: string | null;
  previous_hash: string | null;
}
export function toNameConfigMapping<T extends readonly { config: { name: string } }[]>(list: T) {
  return Object.fromEntries(list.map(q => [q.config.name, q])) as ListToMap<T>;
} // eslint-disable-next-line @typescript-eslint/ban-types

export type ListToMap<L extends readonly { config: { name: string } }[], Acc = {}> = L extends readonly [
  infer H,
  ...infer Rest,
]
  ? H extends { config: { name: string } }
    ? Rest extends { config: { name: string } }[]
      ? ListToMap<
          Rest,
          Acc & {
            [P in H['config']['name']]: H;
          }
        >
      : Acc
    : Acc
  : Acc;
